var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcommerce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 880,
    height: 632,
    viewBox: "0 0 880 632",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M645 0.365005H0.274986V413.275H645V0.365005Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.211 52.654H626.064V388.347H19.211V52.654Z",
    fill: "white",
    stroke: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.725 0H0V27.39H644.725V0Z",
    fill: "#E6015C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.355 19.081C23.1589 19.081 25.432 16.808 25.432 14.004C25.432 11.2001 23.1589 8.927 20.355 8.927C17.551 8.927 15.278 11.2001 15.278 14.004C15.278 16.808 17.551 19.081 20.355 19.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.624 19.081C42.4279 19.081 44.701 16.808 44.701 14.004C44.701 11.2001 42.4279 8.927 39.624 8.927C36.82 8.927 34.547 11.2001 34.547 14.004C34.547 16.808 36.82 19.081 39.624 19.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.893 19.081C61.6969 19.081 63.97 16.808 63.97 14.004C63.97 11.2001 61.6969 8.927 58.893 8.927C56.089 8.927 53.816 11.2001 53.816 14.004C53.816 16.808 56.089 19.081 58.893 19.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.387 79.848H93.5V208.83H212.387V79.848Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08 79.848H263.193V208.83H382.08V79.848Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.772 79.848H432.885V208.83H551.772V79.848Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.387 232.176H93.5V361.158H212.387V232.176Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08 232.176H263.193V361.158H382.08V232.176Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.772 232.176H432.885V361.158H551.772V232.176Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.928 265.325L313.65 256.737L316.176 299.676C316.176 299.676 320.722 312.81 319.207 317.862C319.207 317.862 320.217 326.45 317.691 326.955C315.165 327.46 308.091 328.471 307.591 327.965C307.091 327.459 307.086 325.944 307.086 325.944C307.086 325.944 302.034 329.48 301.529 333.521C301.529 333.521 280.312 340.088 279.807 334.026C279.302 327.964 290.415 322.912 290.415 322.912L299.003 309.778L291.928 265.325Z",
    fill: "#E6015C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.9 265.325L359.619 256.737L362.145 299.676C362.145 299.676 366.691 312.81 365.176 317.862C365.176 317.862 366.186 326.45 363.66 326.955C361.134 327.46 354.06 328.471 353.56 327.965C353.06 327.459 353.055 325.944 353.055 325.944C353.055 325.944 348.003 329.48 347.498 333.521C347.498 333.521 326.281 340.088 325.776 334.026C325.271 327.964 336.384 322.912 336.384 322.912L344.972 309.778L337.9 265.325Z",
    fill: "#E6015C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.022 99.51C340.022 99.51 335.397 112.434 340.756 118.262L336.288 133.615C336.288 133.615 352.162 181.237 347.627 187.889C347.627 187.889 330.695 196.355 296.827 184.865L310.584 131.498L308.619 108.972L311.34 98.389L317.387 97.789C317.387 97.789 313.759 111.395 320.411 113.512C327.063 115.629 333.552 98.129 333.552 98.129L340.022 99.51Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.421 182.937L132.258 185.325L160.116 148.712L168.871 191.692L174.708 190.631C178.452 153.576 181.508 115.781 177.759 97.905L156.136 96.976L146.32 128.287L141.544 149.512L126.421 182.937Z",
    fill: "#E6015C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.678 97.612C480.678 97.612 472.712 108.686 473.101 113.155C473.49 117.624 478.541 190.482 478.541 190.482L490.393 191.065L486.893 138.607L489.807 124.424L496.996 190.482L511.568 190.871L498.551 105.19L496.025 97.613L480.678 97.612Z",
    fill: "#E6015C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.7 276.018C523.585 273.48 519.949 272.108 516.458 271.366C516.558 271.049 505.84 268.834 505.658 269.29L501.617 266.071L489.2 272.518L482.223 267.768L478.982 268.918C479.114 268.346 468.921 270.112 468.921 270.112C466.974 270.182 464.487 270.304 461.703 270.518C451.954 271.268 451.203 296.518 451.203 296.518C455.689 294.683 460.471 293.682 465.316 293.563L467.951 323.763C481.504 322.601 495.718 323.953 510.451 327.263L517.36 303.523L533.449 297.266C533.449 297.266 530.7 282.017 525.7 276.018Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.441 261.637C178.698 259.546 175.703 258.415 172.826 257.804C172.912 257.542 164.077 255.718 163.926 256.094L160.596 253.442L150.367 258.754L144.618 254.841L141.948 255.789C142.057 255.318 133.658 256.772 133.658 256.772C132.058 256.83 130.004 256.93 127.711 257.107C119.678 257.725 119.06 278.528 119.06 278.528C122.756 277.016 126.697 276.191 130.689 276.093L132.86 337.007C144.027 336.049 155.739 337.164 167.875 339.891L173.567 284.301L186.824 279.146C186.824 279.146 184.56 266.582 180.441 261.637Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.45 277.851H806.45V247.351C806.45 239.792 803.447 232.543 798.103 227.198C792.758 221.854 785.509 218.851 777.95 218.851C770.391 218.851 763.142 221.854 757.797 227.198C752.453 232.543 749.45 239.792 749.45 247.351V277.851Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.005 617.195H711.746L705.913 569.903H724.007L724.005 617.195Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.132 613.192H702.987C698.907 613.192 694.993 614.813 692.108 617.698C689.223 620.584 687.602 624.497 687.601 628.577V629.077H727.132V613.192Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.559 600.834L859.883 606.861L831.555 568.55L847.312 559.655L870.559 600.834Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.314 595.811L850.289 607.677C846.736 609.683 844.125 613.019 843.031 616.95C841.937 620.882 842.449 625.086 844.455 628.64L844.701 629.075L879.125 609.642L871.314 595.811Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.205 404.524L793.151 409.254C793.151 409.254 795.989 412.092 794.57 413.511C793.151 414.93 793.624 421.553 793.624 421.553C794.418 433.629 810.197 501.489 813.019 514.742C813.019 514.742 834.779 528.933 851.808 556.842C868.837 584.751 869.308 591.847 869.308 591.847L850.39 599.89L803.09 542.652C803.09 542.652 789.845 534.61 785.114 527.515C780.383 520.42 751.05 447.097 751.05 447.097L734.49 523.73C734.49 523.73 735.436 551.639 731.179 569.615C728.561 580.959 726.978 592.517 726.449 604.147L704.216 601.782C704.216 601.782 705.635 534.61 708 527.514C708 527.514 698.066 445.678 717.934 413.038L733.946 370.351L749.628 364.315L792.205 404.524Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.244 226.307C748.397 226.817 748.402 271.214 778.244 271.719C808.089 271.209 808.085 226.812 778.244 226.307Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.273 247.835H760.346L761.727 244.381L761.036 247.835H788.781L787.881 240.608L794.625 247.835H801.352V243.919C801.354 240.894 800.76 237.897 799.605 235.101C798.449 232.306 796.754 229.765 794.616 227.624C792.478 225.483 789.94 223.784 787.145 222.625C784.351 221.465 781.356 220.867 778.33 220.865C775.305 220.863 772.309 221.456 769.513 222.612C766.717 223.768 764.176 225.463 762.035 227.601C759.894 229.739 758.196 232.277 757.036 235.071C755.876 237.866 755.278 240.861 755.276 243.886V243.919L755.273 247.835Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.466 284.977L803.866 285.434L791.95 406.351C791.95 406.351 725.991 402.87 725.95 382.737L732.129 364.846L747.466 284.977Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.29 418.04C805.423 416.978 804.799 415.739 804.463 414.41C804.127 413.081 804.086 411.695 804.343 410.349C804.601 409.002 805.15 407.729 805.953 406.618C806.756 405.507 807.793 404.585 808.99 403.918L806.539 382.631L819.112 377.986L822.151 408.097C823.132 410.182 823.315 412.555 822.666 414.766C822.017 416.978 820.58 418.874 818.628 420.099C816.675 421.323 814.341 421.789 812.068 421.41C809.795 421.031 807.739 419.832 806.29 418.04Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.45 295.851L803.871 285.478C803.871 285.478 808.95 284.351 814.95 291.351C820.95 298.351 824.45 385.851 824.45 385.851L802.45 390.851L789.45 328.851L796.45 295.851Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.135 390.739L673.771 468.476L724.096 495.071L815.744 478.705L817.995 397.899L759.896 377.441L672.135 390.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.965 495.91L672.978 468.966L671.316 390.05L759.974 376.617L760.163 376.683L818.815 397.335L816.53 479.381L723.965 495.91ZM674.565 467.986L724.227 494.231L814.959 478.029L817.175 398.462L759.818 378.266L672.953 391.427L674.565 467.986Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.973 411.816L722.776 411.738L671.838 391.485L672.431 389.992L723.173 410.166L817.885 397.103L818.105 398.695L722.973 411.816Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.877 410.981L722.27 411.001L723.292 495.08L724.9 495.061L723.877 410.981Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.536 407.792L698.174 400.348L786.569 386.263L804.931 393.706L716.536 407.792Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.452 413.289L671.817 414.766L693.113 423.935L693.749 422.459L672.452 413.289Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.096 439.809L681.46 441.286L702.757 450.455L703.392 448.979L682.096 439.809Z",
    fill: "#E6015C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.135 498.739L393.771 576.476L444.096 603.071L535.744 586.705L537.995 505.899L479.896 485.441L392.135 498.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.965 603.91L392.978 576.966L391.316 498.05L479.974 484.617L480.163 484.683L538.815 505.335L536.53 587.381L443.965 603.91ZM394.565 575.986L444.227 602.231L534.959 586.029L537.175 506.462L479.818 486.266L392.953 499.427L394.565 575.986Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.973 519.816L442.776 519.738L391.838 499.485L392.431 497.992L443.173 518.166L537.885 505.103L538.105 506.695L442.973 519.816Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.877 518.981L442.27 519.001L443.292 603.08L444.9 603.061L443.877 518.981Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.088 513.962L418.174 508.348L506.569 494.263L520.482 499.877L432.088 513.962Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.452 521.289L391.817 522.766L413.113 531.935L413.749 530.459L392.452 521.289Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.096 547.809L401.46 549.286L422.757 558.455L423.392 556.979L402.096 547.809Z",
    fill: "#E6015C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.563 509.397L481.463 599.638L539.882 630.51L646.271 611.512L648.883 517.709L581.44 493.961L479.563 509.397Z",
    fill: "#E6015C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.729 631.484L480.541 600.206L478.613 508.598L581.53 493.004L581.75 493.081L649.834 517.055L647.182 612.296L539.729 631.484ZM482.383 599.069L540.034 629.535L645.359 610.727L647.931 518.363L581.35 494.918L480.513 510.197L482.383 599.069Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.578 533.865L538.35 533.774L479.218 510.264L479.907 508.53L538.81 531.949L648.755 516.785L649.01 518.633L538.578 533.865Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.627 532.896L537.761 532.918L538.949 630.521L540.814 630.498L539.627 532.896Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.888 527.112L509.79 520.553L612.402 504.202L629.501 510.761L526.888 527.112Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.932 535.575L479.194 537.289L503.916 547.933L504.653 546.219L479.932 535.575Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.126 566.36L490.389 568.074L515.11 578.718L515.848 577.004L491.126 566.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.668 403.593C701.909 403.01 703.007 402.163 703.885 401.11C704.762 400.058 705.399 398.825 705.749 397.5C706.099 396.175 706.155 394.789 705.911 393.44C705.668 392.091 705.132 390.812 704.341 389.693L715.763 371.563L706.439 361.935L690.668 387.764C688.876 389.218 687.68 391.279 687.306 393.556C686.932 395.833 687.406 398.169 688.639 400.119C689.871 402.07 691.776 403.502 693.993 404.142C696.21 404.782 698.585 404.587 700.668 403.594V403.593Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.133 289.743L747.95 284.351C747.95 284.351 741.635 285.767 734.919 298.685C728.203 311.603 701.119 369.357 701.119 369.357L712.252 380.657L741.952 335.348L756.133 289.743Z",
    fill: "#3F3D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 879.125,
    height: 631.485,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerce);
export default __webpack_public_path__ + "static/media/ecommerce.b878c5144a53fa83ff8e3f0be17c5d55.svg";
export { ForwardRef as ReactComponent };